import { Inline, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import React from 'react';

const DEFAULT_TOOLBAR_SKELETON_HEIGHT = '16px';
const SECOND_TOOLBAR_SKELETON_WIDTH = '78px';

const toolbarContainerStyles = xcss({
  borderBottom: `1px solid ${token('color.border')}`,
});

const toolbarStyles = xcss({
  gap: 'space.100',
  paddingTop: 'space.250',
  paddingBottom: 'space.250',
  paddingLeft: 'space.500',
  paddingRight: 'space.500',
});

const borderStyles = xcss({
  borderTop: `1px solid ${token('color.border')}`,
});

export const DatabaseToolbarSkeleton = () => {
  return (
    <Stack xcss={toolbarContainerStyles}>
      <Inline xcss={toolbarStyles}>
        <Skeleton height={DEFAULT_TOOLBAR_SKELETON_HEIGHT} width="16px" isShimmering />
        <Skeleton height={DEFAULT_TOOLBAR_SKELETON_HEIGHT} width="180px" isShimmering />
      </Inline>
      <Inline xcss={[toolbarStyles, borderStyles]}>
        <Skeleton
          height={DEFAULT_TOOLBAR_SKELETON_HEIGHT}
          width={SECOND_TOOLBAR_SKELETON_WIDTH}
          isShimmering
        />
        <Skeleton
          height={DEFAULT_TOOLBAR_SKELETON_HEIGHT}
          width={SECOND_TOOLBAR_SKELETON_WIDTH}
          isShimmering
        />
        <Skeleton
          height={DEFAULT_TOOLBAR_SKELETON_HEIGHT}
          width={SECOND_TOOLBAR_SKELETON_WIDTH}
          isShimmering
        />
        <Skeleton
          height={DEFAULT_TOOLBAR_SKELETON_HEIGHT}
          width={SECOND_TOOLBAR_SKELETON_WIDTH}
          isShimmering
        />
      </Inline>
    </Stack>
  );
};
